// Vite replaces import.meta.env.VITE_* at build time with the literal
// values present in the environment when `npm run build` ran. Missing
// values surface as `undefined` at runtime — guard here to fail fast
// rather than after a Cognito call errors with a cryptic message.
//
// Local dev is a deliberate exception: in MSW/mock mode we want `npm run
// dev` and `npm test` to work from a clean checkout without real backend
// or Cognito config. Use inert placeholders there, but keep production
// builds strict.

const allowsLocalPlaceholders = import.meta.env.DEV || import.meta.env.MODE === "test";

function required(name: string, localPlaceholder?: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv] as string | undefined;
  if (value) {
    if (name === "VITE_API_BASE_URL" && value === "." && typeof window !== "undefined") {
      return window.location.origin;
    }
    return value;
  }
  if (allowsLocalPlaceholders && localPlaceholder) {
    return localPlaceholder;
  }
  throw new Error(`missing build-time env var ${name}`);
}

export const env = {
  apiBaseUrl: required("VITE_API_BASE_URL", "http://localhost:5173"),
  cognito: {
    region: import.meta.env.VITE_COGNITO_REGION ?? "eu-west-2",
    userPoolId: required("VITE_COGNITO_USER_POOL_ID", "eu-west-2_localdev"),
    userPoolClientId: required("VITE_COGNITO_CLIENT_ID", "1234567890abcdefghijklmnop"),
  },
};
